module.exports = __webpack_public_path__ + "img/min.8a44e4d2.svg";